import { lazy } from "react";
import { MANUSCRIPT_URL } from "manuscript/constants";
import { Navigate } from "react-router-dom";

import { RouteObject } from "react-router-dom";
import LazyLoader from "base/components/LazyLoader";
import {
  MANUSCRIPT_LIST_URL,
  MANUSCRIPT_VIEW_URL,
  MANUSCRIPT_BOOK_URL,
} from "manuscript/constants/route";

const MainContainer = LazyLoader(
  lazy(() => import("manuscript/containers/MainContainer"))
);
const ListPageContainer = LazyLoader(
  lazy(() => import("manuscript/containers/ListPageContainer"))
);
const ViewPage = LazyLoader(lazy(() => import("manuscript/pages/ViewPage")));

const routes: RouteObject = {
  path: MANUSCRIPT_URL,
  element: <MainContainer />,
  children: [
    {
      index: true,
      element: <Navigate to={MANUSCRIPT_BOOK_URL} />,
    },
    {
      path: `${MANUSCRIPT_LIST_URL}/:category_type/:category_id?`,
      element: <ListPageContainer />,
    },
    {
      path: `${MANUSCRIPT_VIEW_URL}/:category_type/:category_id/:manuscript_id`,
      element: <ViewPage />,
    },
  ],
};

export default routes;
